import { useTranslation } from 'react-i18next';
import QRCode from 'react-qr-code';

import type { ReactNode } from 'react';

import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';

type QrCodeDialogProps = {
  isOpen: boolean;
  value: string;
  title: string;
  description: string;
  children?: ReactNode;
  onClose: () => void;
};

export const QrCodeDialog = (props: QrCodeDialogProps) => {
  const { isOpen, value, title, description, children, onClose } = props;
  const { t } = useTranslation();

  return (
    <Dialog
      open={isOpen}
      onOpenChange={onClose}
    >
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
          <DialogDescription>{description}</DialogDescription>
        </DialogHeader>
        <div className="flex flex-col items-center gap-4 py-4">
          <div className="rounded-lg bg-white p-4">
            <QRCode value={value} />
          </div>
          {children}
        </div>
        <DialogFooter>
          <Button onClick={onClose}>{t('Close')}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
